import { z } from "zod/v4-mini";

export type AbsenceMessageFormData = {
  contentText: string;
};

export const absenceMessageFormSchema = z.object({
  contentText: z.string("form.required").check(z.minLength(1)),
});
